











import { Component, Vue } from "vue-property-decorator";
import AppHeader from "@/layouts/AppHeader.vue";

@Component({ components: { AppHeader } })
export default class AppReportsLayout extends Vue {
  get previousRoute() {
    return this.$route.params.fromRoute;
  }
}
